import { Helmet } from "react-helmet-async";
import { IMAGES } from "@/lib/content";

const SITE = "https://planettrotterfoundation.com";
const DEFAULT_TITLE = "Planet Trotter Foundation | Conservation, Communities & Responsible Tourism in India";
const DEFAULT_DESC =
  "Planet Trotter Foundation works on conservation, responsible travel and community development in India and beyond.";

// jsonLd: object or array of schema.org objects rendered as JSON-LD.
export default function Seo({ title, description, path = "", image, jsonLd }) {
  const fullTitle = title ? `${title} | Planet Trotter Foundation` : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESC;
  const url = `${SITE}${path}`;
  const ogImage = image || IMAGES.hero;
  const gsc = process.env.REACT_APP_GSC_VERIFICATION;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {gsc && <meta name="google-site-verification" content={gsc} />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Planet Trotter Foundation" />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
